module.exports = __webpack_public_path__ + "static/media/load_support.4f831441.png";